import { css } from '@emotion/css'
import { spacing, borderRadius, fontSize, fontWeight, fontFamily } from '../../styles'
import { colors } from '../../themes'

const styles = {
  wrapper: css({
    borderRadius: borderRadius.default,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.body,
    lineHeight: 1.4,
    color: colors.jumbo,
    boxSizing: 'border-box',
  }),
}

export default styles

export const wrapperTheme = theme => {
  switch (theme) {
    case 'dark':
      return css({
        backgroundColor: colors.porcelain,
      })

    default:
      return css({
        backgroundColor: colors.athensGray,
      })
  }
}

export const wrapperSize = size => {
  switch (size) {
    case 'small':
      return css({
        padding: spacing.small,
      })

    case 'medium':
      return css({
        padding: spacing.medium,
      })

    default:
      return css({
        padding: spacing.default,
      })
  }
}
